/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Jadwal_OkInputs */

const en_tut_jadwal_ok = /** @type {(inputs: Tut_Jadwal_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The countdown turns into **Waktunya tiba · menunggu host**, and the banner only shows while it is still unread.`)
};

const id_tut_jadwal_ok = /** @type {(inputs: Tut_Jadwal_OkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hitung mundur berganti menjadi **Waktunya tiba · menunggu host**, dan banner pengingat hanya muncul selama belum Anda baca.`)
};

/**
* | output |
* | --- |
* | "The countdown turns into **Waktunya tiba · menunggu host**, and the banner only shows while it is still unread." |
*
* @param {Tut_Jadwal_OkInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_jadwal_ok = /** @type {((inputs?: Tut_Jadwal_OkInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Jadwal_OkInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_jadwal_ok(inputs)
	return en_tut_jadwal_ok(inputs)
});